import { render } from "./talentNetwork.vue?vue&type=template&id=3ffbd3d0&scoped=true"
import script from "./talentNetwork.vue?vue&type=script&lang=js"
export * from "./talentNetwork.vue?vue&type=script&lang=js"

import "./talentNetwork.vue?vue&type=style&index=0&id=3ffbd3d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffbd3d0"]])

export default __exports__